import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import React, { ReactNode } from 'react';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';

/**
 * Disabling retries for all queries by default
 * This can be overridden in individual query options at the hook level
 * @see https://tanstack.com/query/latest/docs/framework/react/guides/query-retries
 */

const client = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
    },
  },
});

type ClientProviderProps = {
  children: ReactNode;
  reactClass?: string;
};

export const V3ApiClientProvider = ({
  children,
  reactClass,
}: ClientProviderProps) => {
  // this prevents a @tanstack/react-query queryClient instance
  // wrapped around the Toast component, where we don't need access to any data

  const ignoredReactClasses = ['Toast'];
  const shouldRenderClientProvider = !ignoredReactClasses.includes(reactClass);

  if (shouldRenderClientProvider) {
    return (
      <QueryClientProvider client={client}>
        <ReactQueryDevtools
          initialIsOpen={false}
          position="bottom"
          buttonPosition="bottom-right"
        />
        {children}
      </QueryClientProvider>
    );
  }
  return children;
};
